<template>
    <div class="more-phone">
        <div class="phone-s" v-for="(item, index) in options" :key="index">
            <div class="phone-a-c">
                <phone-com class="phone-com" :comPhone="item.phone"
                    :vagaryPhone="Object.hasOwnProperty.call(item, 'vagary_phone') ? item.vagary_phone : false" />
                <el-tooltip class="item" effect="dark" content="外呼" placement="top">
                    <i @click="
            call(
                item.vagary_phone ? item.vagary_phone : item.phone
            )
            " class="el-icon-phone-outline" style="color: #409eff; cursor: pointer; margin-left: 0.1rem"></i>
                </el-tooltip>
            </div>
            <div>
                <span>
                    {{ item.province }} {{ item.city }}
                </span>
                <el-tag type="success" effect="dark" size="mini"
                    v-if="item.weixinStatus && item.weixinStatus === '活跃号'">
                    是微信
                </el-tag>
                <el-tag type="danger" effect="dark" size="mini"
                    v-else-if="item.weixinStatus && item.weixinStatus !== '活跃号'">
                    {{ item.weixinStatus }}
                </el-tag>
            </div>
            <span>
                手机号姓名: {{ item.name }}
            </span>
            <span v-if="item.position && item.position.length">
                职位: {{ item.position.join('、') }}
            </span>
        </div>
    </div>
</template>

<script>
import PhoneCom from "common/PhoneCom";
export default {
    name: 'MorePhone',
    props: {
        options: {
            type: Array
        }
    },
    components: { PhoneCom },
    methods: {
        call(phone) {
            if (!phone) {
                this.$message.error("手机号为空");
                return;
            }
            // this.$axios.post("/api/admin/call_logs/" + num).then((res) => {
            this.$axios
                .post("api/admin/call_logs_call", {
                    phone,
                })
                .then((res) => {
                    let { data } = res;
                    if (data.code === 0) {
                        this.$message.success("调用成功，请注意接听来电");
                        setTimeout(this.getCallLogs(this.order.customer_phone), 500);
                    } else {
                        this.$message.error(data.msg);
                    }
                });
        },
    }
}
</script>

<style scoped>
.more-phone {
    background-color: #F2F6FC;
    padding: 0.2rem 0;
}

.more-phone .phone-com {
    margin-left: -0.1rem;
}

.more-phone .phone-s {
    display: flex;
    /* align-items: center; */
    align-items: flex-start;
    /* justify-content: space-evenly; */
    justify-content: center;
    flex-direction: column;
    margin-bottom: 0.3rem;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, .3);
    border-radius: 15px;
    width: fit-content;
    padding: 0.2rem 0.5rem;
    margin-left: auto;
    margin-right: auto;
    background-color: white;
}

.more-phone .phone-a-c {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: row;
}
</style>


// WEBPACK FOOTER //
// src/pages/cloudClue/Components/MorePhone.vue